import React from 'react'
import { LinearProgress } from '@mui/material';
import useLocation from '../../hooks/useLocation';
import useUser from '../../hooks/useUser';
import WriteLog from '../Globals/WriteLog';


//table
import { styled, ThemeProvider, createTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useState } from 'react';
import StyledStatusCell from './StyledStatusCell';

//form
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';


//heroicons
import{
    EllipsisHorizontalIcon,  
    XMarkIcon  
}from "@heroicons/react/24/outline"


//split panel
import SplitPane, { Pane } from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css'
import STPopup from '../Globals/STPopup';
import axios from 'axios';
import useEstimate from '../../hooks/useEstimate';


//Theme    
const theme = createTheme({
    status: {
        danger: '#f00',
    },
    palette: {
        primary: {
        main: '#777',
        darker: '#000',
        },
        neutral: {
        main: '#f00',
        contrastText: '#fff',        
        },
    },
    });
    
function Estimate({addrSeq}) {
    
    const { user } = useUser();
    
    //estimate
    var {estimates, mutate} = useEstimate(user?.customer_code, addrSeq, user?.token)
    
    WriteLog("Estimate->estimates", estimates); 
    WriteLog("Estimate->addrSeq", addrSeq); 

    
    //detail
    const [details, setDetails] = useState(false)
    const [est, setEst] = useState(null)
    const [items, setItems] = useState(null)
    
    const handleShowDetails = (e, estNbr)=>{        
        e.preventDefault()
        //const filterOption = e.target.value;
        const estimate = estimates?.filter(est=>est.est_nbr === estNbr)
        if(estimate?.length>0) setItems(estimate[0].items);
        WriteLog("Estimate->items", est)        
        setEst(estimate)
        setDetails(true)
        setSizes("700","200")
    }

    const handleCloseDetails = (e)=>{        
        e.preventDefault()        
        setItems(null);                
        setEst(null)
        setDetails(false) 
        setSizes("auto","0%")       
    }
    
    //split panel
    const [sizes, setSizes] = useState([
        'auto',
        '0%',        
    ]);
    
    // const layoutCSS = {
    //     height: '100%',
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    // };

    //status filter    
    const [statusFilter, setStatusFilter] = useState("-1")

    WriteLog("Estimate->estimates-statusFilter", statusFilter);
    
    const handleStatusFilterChange = (e)=>{
        //const filterOption = e.target.value;
        e.preventDefault();        
        setStatusFilter(e.target.value);        
        WriteLog("Estimate->handleStatusFilterChange->estimates", estimates)        
    }; 
    
    if(estimates)
    {
        estimates = filterEstimate() 
        WriteLog("Estimate->estimates-Filtered", estimates);
    }
    
    function filterEstimate()
    {
        WriteLog("Estimate->filterEstimate", statusFilter)
        if(statusFilter == -1) 
            return estimates
        else
            return estimates?.filter(d=>d.status == statusFilter)
    }
    

    //location
    const { locations } = useLocation(user?.customer_code, user?.token);                
    WriteLog("Estimate->locations", locations);      
    var location = locations?.locations?.filter(l=> l.AddrSeq == addrSeq);
    if(location?.length>0) location = location[0];
    WriteLog("Estimate->location", location);


  
    // //estimate/customer/{cust_code}/status
    // const fetcher = Fetcher();    
    // WriteLog("useReport->Endpoint",process.env.NEXT_PUBLIC_SERVER_BASE_URL +'/estimate/customer/'+ user?.data?.customer_code +'/estimates?addr_seq='+addrSeq);
    // const { data, mutate, error } = useSWR([process.env.NEXT_PUBLIC_SERVER_BASE_URL +'/estimate/customer/'+ user?.data?.customer_code+'/estimates?addr_seq='+addrSeq, 
    //     {   method: 'GET',
    //         headers: {
    //                     'Authorization': user?.token,
    //                 }
    //     }
    // ], fetcher)
    // const estimates = filterEstimate(statusFilter, data) 

    
    //Table
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "#DDD",
          color: theme.palette.common.black,   
          height:60       
        },
        [`&.${tableCellClasses.body}`]: {          
          border:'3px solid #FFF',           
          height:50,
          padding:5,
          margin:0,          
        },
        [`&.${tableCellClasses.root}`]: {            
            border:'3px solid #FFF',            
          },        
          [`&.${tableCellClasses.hover}`]: {            
            backgroundColor: "#0F0",
          },        
      }));
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,   
                     
        },       
        //hide last border
        // "&:last-child td, &:last-child th": {
        //     border: 0,
        // },
    }));    
    //approval
    const [changeStatus, setChangeStatus] = useState(false)
    const [showApprovalPopup, setShowApprovalPopup] = useState(false)
    
    const openApprovalPopUp = (e,es)=>{     
        e.preventDefault();    
        setEst(es);           
        setShowApprovalPopup(true);
    }

    const handleApproval = (e)=>{
        e.preventDefault();    
        setChangeStatus(true);   
        postData(1)         
    }

    const handleReject = (e)=>{
        e.preventDefault();   
        setChangeStatus(true);     
        postData(2) 
    }
        
    const postData = async (status) => {

        WriteLog("Estimate->changestatus",process.env.REACT_APP_SERVER_BASE_URL +'/estimate/customer/'+ user?.customer_code +'/status?est_nbr='+est.est_nbr+'&status='+status);
        await axios.put(process.env.REACT_APP_SERVER_BASE_URL +'/estimate/customer/'+ user?.customer_code +'/status?est_nbr='+est.est_nbr+'&status='+status,
        {
            
        },
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': user?.token,                    
            },
        },            
        ).then(function (res){
            WriteLog("Estimate->PostData", res.data)
            //estimates = res.data;
            setChangeStatus(false);
            setShowApprovalPopup(false)   
            mutate()         
        }).catch(function (error){

            setChangeStatus(false);
            setShowApprovalPopup(false)
            console.log('New Post-> Error', error);
        })                               
    }

    //date conversion
    function convertUTCDateToLocalDate(date) {
        var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);    
        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();    
        newDate.setHours(hours - offset);    
        return newDate;   
    }

    return (
        <div className="flex-grow h-screen bg-white"> 
        <div className='flex pl-5 pt-5 items-center space-x-3'>
            <div className='text-3xl font-bold'>Estimates:</div>      
            <div className='bg-slate-300 rounded-full w-8 h-8 p-1 text-center'>{estimates?.length}</div>      
        </div>                   
            <div className='h-screen'>                                
                    <div className='w-full'>
                    <div className='flex ml-1 items-baseline justify-between'>
                    <div className='flex ml-10 mt-2 items-baseline space-x-2'>
                        <div className='text-xl text-gray-500 font-bold'>Location:</div>
                        <div className='text-sm'>{addrSeq>=0?location?.Name:"All"}</div>
                    </div>                        
                        <div className='justify-center bg-gray-200 rounded-xl mr-10'>
                        <div className='flex text-right p-2 ml-5'>
                                <FormControl id="TaskSelection">                                
                                    <ThemeProvider theme={theme}>                                    
                                        <RadioGroup name='taskFiler' row value={statusFilter} onChange={(e)=>handleStatusFilterChange(e)} >                                    
                                            <FormControlLabel value="-1" control={<Radio color='primary'  size='small' />} label="All" />
                                            <FormControlLabel value="0"  control={<Radio color='primary'  size='small' />} label="Waiting Approval" />
                                            <FormControlLabel value="1"  control={<Radio color='primary'  size='small' />} label="Accepted" />
                                            <FormControlLabel value="2"  control={<Radio color='primary'  size='small' />} label="Rejected" />                                    
                                        </RadioGroup>
                                    </ThemeProvider>                                
                                </FormControl>          
                            </div>
                        </div>                                                          
                    </div>                      
                    <div className='pl-10 pt-1 pr-10'>
                        {!estimates &&
                            <LinearProgress color='primary' />
                        }
                    </div>
                    <div className='ml-10 mr-10'>                                  
                        <TableContainer component={Paper}>
                            <Table>
                                <colgroup>
                                    <col width="10%" />
                                    <col width="30%" />
                                    <col width="20%" />
                                    <col width="13%" />
                                    <col width="12%" />
                                    <col width="10%" />
                                </colgroup>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="left">Estimate #</StyledTableCell>
                                        <StyledTableCell align="left">Description</StyledTableCell>
                                        <StyledTableCell align="center">Date</StyledTableCell>                          
                                        <StyledTableCell align="center">Total</StyledTableCell>                                                      
                                        <StyledTableCell align="center">Status</StyledTableCell>
                                        <StyledTableCell align="center">Details</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody> 
                                    {estimates?.map((est) => ( 
                                        <StyledTableRow key={`${est.est_nbr}`}>
                                            <StyledTableCell align="center">
                                                <div className='flex justify-left h-full items-center'>
                                                    {est.status === 0 &&
                                                        <div className='h-full w-1 bg-[#FF7B54]'></div>
                                                    }
                                                    {est.status === 1 &&
                                                        <div className='h-full w-1 bg-[#24a33f]'></div>
                                                    }
                                                    {est.status === 2 &&
                                                        <div className='h-full w-1 bg-[#ed6666]'></div>
                                                    }
                                                    
                                                    <div className="text-gray-500 ml-4 text-sm">{est.est_nbr}</div>
                                                </div>                                                
                                            </StyledTableCell>                                                                       
                                            <StyledTableCell align="left"><div className="text-gray-500 text-sm">{est.desc}</div></StyledTableCell>                          
                                            <StyledTableCell align="center">
                                            <div className="text-gray-500 text-sm">
                                                {est.create_date !== "" &&
                                                    <div className="text-gray-600 text-sm">                                
                                                        {
                                                        new Intl.DateTimeFormat("en-GB", {
                                                            year: "numeric",
                                                            month: "long",
                                                            day: "2-digit",
                                                            hour: 'numeric', 
                                                            minute: 'numeric',                                     
                                                            hour12: true,
                                                        }).format(convertUTCDateToLocalDate(new Date(est.create_date)))
                                                        }                                                                
                                                    </div>
                                                }                            
                                            </div></StyledTableCell>                                                        
                                            <StyledTableCell align="center"><div className="text-gray-500 text-sm">$ {est.dest_total}</div></StyledTableCell>                                              
                                            <StyledStatusCell status={est.status} desc={est.status === 0?'Awaiting Approval':est.status === 1?'Accepted':'Rejected'} id={est.est_nbr} onclick={(e)=>openApprovalPopUp(e, est)} ></StyledStatusCell>
                                            <StyledTableCell align="center">
                                                <div className='flex justify-evenly cursor-pointer hover:bg-gray-200 hover:text-orange-600 rounded-lg' onClick={(e)=>handleShowDetails(e, est.est_nbr)} >
                                                    <EllipsisHorizontalIcon className='w-10 h-10 '/>
                                                </div>
                                            </StyledTableCell>                                                                                         
                                        </StyledTableRow>                  
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer> 
                    </div>  
                </div> 
                
                    {details &&
                        <div className='ml-10 mr-10'>                    
                        <div className='flex justify-between ml-1 items-center'>
                            <div className='ml-1 mt-2 text-3xl font-bold'>Details(s):{est.est_nbr} </div>                             
                            <div className="p-1 bg-gray-200 rounded-full hover:bg-gray-300 cursor-pointer" onClick={(e)=>handleCloseDetails(e)}>
                                <XMarkIcon className="w-6 h-6 text-gray-700" />
                            </div>                        
                        </div>                    
                        <div className='flex'>
                            <TableContainer component={Paper}>
                                <Table>
                                    <colgroup>
                                            <col width="10%" />
                                            <col width="35%" />
                                            <col width="20%" />
                                            <col width="13%" />                                        
                                    </colgroup>
                                    <TableHead>
                                        <TableRow>                                        
                                            <StyledTableCell align="center">Code</StyledTableCell>
                                            <StyledTableCell align="left">Description</StyledTableCell>
                                            <StyledTableCell align="center">Quantity</StyledTableCell>                          
                                            <StyledTableCell align="center">Price</StyledTableCell>                                                                                              
                                        </TableRow>
                                    </TableHead>
                                    <TableBody> 
                                        {items?.map((item) => ( 
                                            <StyledTableRow key={`${item.item_code}-${item.line_nbr}`}>
                                                <StyledTableCell align="center"><div className="text-gray-500 text-sm">{item.item_code}</div></StyledTableCell>                          
                                                <StyledTableCell align="center"><div className="text-gray-500 text-sm">{item.desc}</div></StyledTableCell>                          
                                                <StyledTableCell align="center"><div className="text-gray-500 text-sm">{item.est_qty}</div></StyledTableCell>                          
                                                <StyledTableCell align="center"><div className="text-gray-500 text-sm">$ {item.dprice}</div></StyledTableCell>                          
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer> 
                        </div>                    
                        </div>
                    }                                    
            </div>
            {showApprovalPopup &&
            
            <STPopup title={"Approval"} trigger ={showApprovalPopup} setTrigger = {setShowApprovalPopup}>
                {changeStatus &&
                    <div>
                        <LinearProgress color='primary' />
                    </div>
                }                
                <div className='text-center mt-2'>
                    <div className=''>#{est.est_nbr}</div>
                    <div>{est.desc}</div>
                </div>
                <div className='flex w-full items-center justify-center mt-5'>
                    <div className='w-1/2 text-center bg-green-500 p-3 text-white m-5 rounded-lg cursor-pointer hover:bg-green-600' onClick={(e)=>handleApproval(e)}>Approve</div>
                    <div className='w-1/2 text-center bg-red-500 p-3 text-white m-5 rounded-lg cursor-pointer hover:bg-red-600' onClick={(e)=>handleReject(e)}>Reject</div>
                </div>                
            </STPopup>            
            }
        </div>
    )
  }

export default Estimate


//dragging
    //const [screenWidth, setScreenWidth] = useState('w-[190px]');
    //const [screenLastWidth, setScreenLastWidth] = useState(160);
    //const [dragging, setDragging] = useState(false);
    //const [mouseStart, setMouseStart] = useState({ x: 0, y: 0 });
    
    // const handleMouseDown = (e)=>{
    //     e.preventDefault()
    //     setDragging(true);
    //     setMouseStart({ x: e.clientX, y: e.clientY });
    //     WriteLog("Estimate->pixelDifference->mouseStart", mouseStart)
    //     // var x = 220
    //     // var xSt = 'w-['+x+'px]';        
    //     // setScreenWidth(xSt);
    //     // WriteLog("Estimate->pixelDifference->screenWidth", screenWidth)
    // }

    // const handleMouseUp = (e)=>{
    //     e.preventDefault()
    //     setDragging(false);      
    //     // var x = 320
    //     // var xSt = 'w-['+x+'px]';        
    //     // setScreenWidth(xSt);        
    //     // WriteLog("Estimate->pixelDifference->screenWidth", screenWidth)
    // }

    // const handleMouseMove = (e)=>{
    //     e.preventDefault()        
    //     if (dragging) {   
                        
    //         const pixelDifference = e.clientX - mouseStart.x;
    //         //WriteLog("Estimate->pixelDifference->mouseStart.x", pixelDifference)    
    //         //WriteLog("Estimate->pixelDifference->e.clientX", e.clientX)
    //         //WriteLog("Estimate->pixelDifference", pixelDifference)    
    //         WriteLog("Estimate->pixelDifference->pixelDifference", pixelDifference)    
            

    //         //var x = 320
    //         var x =101
    //         //var xSt = 'w-['+x+'rem]';        
    //         var xSt =`w-[${x}px]` 
    //         WriteLog("Estimate->pixelDifference->xSt", xSt)
    //         var xSt1 = `w-[101px]` 
            
    //         WriteLog("Estimate->pixelDifference->xSt", xSt1)
    //         if(xSt === xSt1)
    //             WriteLog("Estimate->pixelDifference->xSt", "Match")
    //         else
    //             WriteLog("Estimate->pixelDifference->xSt", "NOT Match")
            
    //         setScreenWidth(xSt);        
    //         //WriteLog("Estimate->pixelDifference->x", x)


    //         // var x = screenLastWidth + pixelDifference
    //         // setScreenLastWidth(x)
    //         // var xSt = 'w-['+x+'px]';
    //         // WriteLog("Estimate->pixelDifference->xSt", xSt)    
    //         // setScreenWidth(xSt)            
            
    //       }          
    // }